import { useNewCode } from '@calendly/feature-check-react'

import { CheckboxStatus } from './checkbox_status'
import { RadioStatus } from './radio_status'

export const Status = ({ params, onChange, useColumnLayout = false }) => {
  const useSaFilterSettingsFlag = useNewCode('sa_filter_settings_mtg_pg', false)?.enabled

  return useSaFilterSettingsFlag
    ? <CheckboxStatus params={params} onChange={onChange} useColumnLayout={useColumnLayout} />
    : <RadioStatus params={params} onChange={onChange} />
}
